import { convertDateStringtoMoment, formFlagToBoolean } from '@/utilz';
import moment from 'moment';
import type { OCClaimInitialValuesResponse } from './api';

export const normalizeOCClaimInitialValues = (data: OCClaimInitialValuesResponse) => {
  if (!data) {
    return null;
  }
  return {
    currencyCode: data?.currencyCode,
    statusCode: data?.statusCode,
    reasonCode: data?.reasonCode,
    ocTypeKey: data?.ocTypeKey ? data?.ocTypeKey : undefined,
    auditedBy: data?.auditedBy,
    dateSubmitted: moment(new Date()),
    carrierClaimNo: data?.carrierClaimNo,
    carrierKey: data?.carrierKey ? data?.carrierKey : undefined,
    carrierName: data?.carrierName,
    carrierEmail: data?.carrierEmail,
    carrierDisplayAddress: data?.carrierDisplayAddress ? data?.carrierDisplayAddress : '',
    fbAttach: formFlagToBoolean(data?.fbAttach),
    bolAttach: formFlagToBoolean(data?.bolAttach),
    invAttach: formFlagToBoolean(data?.invAttach),
    otherAttach: formFlagToBoolean(data?.otherAttach),
    otherDesc: data?.otherDesc,
    checkNoFromCarrier: data?.checkNoFromCarrier,
    checkNoToCustomer: data?.checkNoToCustomer,
    ammendmentDate: convertDateStringtoMoment(data?.ammendmentDate) ?? undefined,
    closedDate: convertDateStringtoMoment(data?.closedDate) ?? undefined,
    checkDateToCustomer: convertDateStringtoMoment(data?.checkDateToCustomer) ?? undefined,
    customerClaimNo: data?.customerClaimNo,
    customerName: data?.customerName,
    preparedBy: data?.preparedBy,
    submittedBy: data?.submittedBy,
    customerDisplayAddress: data?.customerDisplayAddress,
    recoverySum: data?.recoverySum,
  };
};
